import React from 'react';
import { useNavigation } from '@react-navigation/native';
import StubScreen from './_StubScreen';

export default function ShopSignupScreen() {
  const navigation = useNavigation();
  return (
    <StubScreen
      title="Shop Sign-Up"
      sourcePath="garageiq-web/app/shop/signup/page.js"
      summary="Onboarding form for independent shops to list themselves on the GarageIQ marketplace. Includes tier selection (Starter / Pro / Premium) and a registration modal."
      todo={[
        'TierCard components → port as plain View cards. shopSubscriptionTiers comes from lib/shopData.js (already in mobile/src/lib/).',
        'Replace web <form> with controlled TextInput state + submit handler.',
        'No backend yet — current web version stores submissions in-memory; route to TODO API in v2.',
        'Tier comparison table is grid-based; flatten to vertical cards on mobile.',
      ]}
      ctaLabel="Open Shop Dashboard →"
      onCta={() => navigation.navigate('ShopDashboard')}
    />
  );
}
